import Vue from "vue";
import VueAnalytics from "vue-analytics";
import VueLogger from "vuejs-logger";
import App from "./App.vue";
import router from "./router";
import formValidator from "./mixins/form-validator";
import store from "./store";
import config from "./config";
import VueDOMPurifyHTML from 'vue-dompurify-html';
import DOMPurify from 'dompurify';

const isProduction = process.env.NODE_ENV === "production";

Vue.directive('sanitize-href', {
  bind(el, binding) {
    el.setAttribute('href', DOMPurify.sanitize(binding.value, { ALLOWED_TAGS: [], ALLOWED_ATTR: ['href'] }));
  },
  update(el, binding) {
    el.setAttribute('href', DOMPurify.sanitize(binding.value, { ALLOWED_TAGS: [], ALLOWED_ATTR: ['href'] }));
  }
});

// Configuración del módulo
Vue.use(config);

// Vue Logger
Vue.use(VueLogger, {
  isEnabled: true,
  logLevel: isProduction ? "error" : "debug",
  stringifyArguments: false,
  showLogLevel: true,
  showMethodName: true,
  separator: "|",
  showConsoleColors: true,
  VueDOMPurifyHTML,
  DOMPurify
});

// Pixeles
// (llamar al último)
//Vue.use(pixels);

/**
 * Instanciar la app luego de obtener y
 * aplicar la configuración del módulo
 */
config.start(() => {
  // Inicializar la app
  const BBVA_APP = new Vue({
    router,
    store,
    mixins: [formValidator],
    render: h => h(App)
  }).$mount("#bbva");

  // Google Analytics
  // Necesitamso el config del id
  // por eso llamamos acá
  if (config.get() && config.get().googleAnalyticsId) {
    Vue.use(VueAnalytics, {
      id: config.get().googleAnalyticsId,
      router,
      autoTracking: {
        exception: true,
        pageviewOnLoad: false
      }
    });
  }

  // Agregar timestamp de versionado si existe
  let app_version = process.env.VUE_APP_BBVA_VERSION || null;
  if (app_version) {
    BBVA_APP.version = app_version;
  }

  // Exponemos la instancia al scope global
  // Útil para hacer modificaciones desde afuera
  window.BBVA_APP = BBVA_APP;
  return BBVA_APP;
});
